import React, { Component, Fragment } from 'react';
import { Row } from 'reactstrap';
import API from '../../../utils/API';
import moment from 'moment';
import { Col, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import InputField from '../../../components/inputs/inputField.js';
import TimeField from '../../../components/inputs/timeField';


import TextAreaField from '../../../components/inputs/textAreaField';
import SelectField from '../../../components/inputs/selectField';
const paymentOptions = [
	{ label: "Room and Tax to Master", value: "Room and Tax to Master" },
	{ label: "All Charges to Master", value: "All Charges to Master" },
	{ label: "Attendee Pay on Own", value: "Attendee Pay on Own" },
	{ label: "Split", value: "Split" },
];

class EventAttendeeRooming extends Component {
	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.state = {
			editing: false,
			editedAttendee: props.editedAttendee,
			genExpanded: true,
			popoverOpen: false,
			popoverIsOpen: false,
			popoverOpen3: false,
			popoverIsOpen4: false,
		};
	}
	componentDidUpdate(prevProps) {
		const { editedAttendee } = this.props;

		// Check if relevant dates have changed
		const datesChanged =
			prevProps.editedAttendee.travelInformation?.arrivalDate !== editedAttendee.travelInformation?.arrivalDate ||
			prevProps.editedAttendee.roomingInformation?.checkInDate !== editedAttendee.roomingInformation?.checkInDate ||
			prevProps.editedAttendee.roomingInformation?.arrivalDate !== editedAttendee.roomingInformation?.arrivalDate ||
			prevProps.editedAttendee.travelInformation?.departureDate !== editedAttendee.travelInformation?.departureDate ||
			prevProps.editedAttendee.roomingInformation?.checkOutDate !== editedAttendee.roomingInformation?.checkOutDate ||
			prevProps.editedAttendee.roomingInformation?.departureDate !== editedAttendee.roomingInformation?.departureDate;

		if (datesChanged) {
			// Recalculate travel mismatch
			const flightArrival = editedAttendee.travelInformation?.arrivalDate
				? moment(new Date(editedAttendee.travelInformation.arrivalDate)).format('MM/DD/YYYY')
				: '';
			const hotelCheckin = editedAttendee.roomingInformation?.checkInDate
				? moment(new Date(editedAttendee.roomingInformation.checkInDate)).format('MM/DD/YYYY')
				: '';
			const eventArrival = editedAttendee.roomingInformation?.arrivalDate
				? moment(new Date(editedAttendee.roomingInformation.arrivalDate)).format('MM/DD/YYYY')
				: '';

			const isFlightValid = flightArrival && flightArrival !== 'Invalid date';
			const isEventValid = eventArrival && eventArrival !== 'Invalid date';
			const isHotelValid = hotelCheckin && hotelCheckin !== 'Invalid date';

			// Check for conflicts - same logic as in travel component
			const hasDateConflict =
				(isFlightValid && isHotelValid && flightArrival !== hotelCheckin) ||
				(isEventValid && isHotelValid && eventArrival !== hotelCheckin) ||
				(isFlightValid && isEventValid && flightArrival !== eventArrival);

			// Recalculate travel mismatch for departures
			const flightDeparture = editedAttendee.travelInformation?.departureDate
				? moment(new Date(editedAttendee.travelInformation.departureDate)).format('MM/DD/YYYY')
				: '';
			const hotelCheckout = editedAttendee.roomingInformation?.checkOutDate
				? moment(new Date(editedAttendee.roomingInformation.checkOutDate)).format('MM/DD/YYYY')
				: '';
			const eventDeparture = editedAttendee.roomingInformation?.departureDate
				? moment(new Date(editedAttendee.roomingInformation.departureDate)).format('MM/DD/YYYY')
				: '';

			const isFlightDepartureValid = flightDeparture && flightDeparture !== 'Invalid date';
			const isEventDepartureValid = eventDeparture && eventDeparture !== 'Invalid date';
			const isHotelCheckoutValid = hotelCheckout && hotelCheckout !== 'Invalid date';

			// Check for departure conflicts
			const hasDepartureDateConflict =
				(isFlightDepartureValid && isHotelCheckoutValid && flightDeparture !== hotelCheckout) ||
				(isEventDepartureValid && isHotelCheckoutValid && eventDeparture !== hotelCheckout) ||
				(isFlightDepartureValid && isEventDepartureValid && flightDeparture !== eventDeparture);

			// Update travelMismatch if it has changed
			const overallMismatch = hasDateConflict || hasDepartureDateConflict;
			if (editedAttendee.travelMismatch !== overallMismatch) {
				this.props.editRoomingFields({
					...this.props.editedAttendee,
					travelMismatch: overallMismatch
				});
			}
		}
	}

	toggleEditing = () => {
		this.setState({ editedAttendee: this.props.attendee, editing: true });
	};
	toggle = () => {
		this.setState({
			popoverOpen: !this.state.popoverOpen
		});
	}

	toggle2 = () => {
		this.setState({
			popoverIsOpen: !this.state.popoverIsOpen
		});
	}
	toggle3 = () => {
		this.setState({
			popoverOpen3: !this.state.popoverOpen3
		});
	}
	toggle4 = () => {
		this.setState({
			popoverIsOpen4: !this.state.popoverIsOpen4
		});
	}

	saveInfo = async () => {
		const { eventId, orgId } = this.props;
		const { editedAttendee } = this.state;
		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/attendees/${editedAttendee._id}`, {
				...editedAttendee
			})
			.then((res) => {
				if (res.data) {
					this.props.updateAttendee(editedAttendee._id, res.data);
					this.setState({ editing: false, editedAttendee: res.data });
				}
			})
			.catch((e) => {
				this.setState({
					invalid: true,
					submitting: false
				});
			});
	};

	cancelEdit = () => {
		this.setState({ editedAttendee: this.props.attendee, editing: false });
	};

	render() {
		const { editing } = this.state;
		const { readOnly, editedAttendee } = this.props;

		const arrivalDate = moment(`${editedAttendee.roomingInformation.arrivalDate}`).format('YYYY-MM-DD');
		const arrivalTime = editedAttendee.roomingInformation.arrivalTime;
		const checkInDate = moment(`${editedAttendee.roomingInformation.checkInDate}`).format('YYYY-MM-DD');
		const departureDate = moment(`${editedAttendee.roomingInformation.departureDate}`).format('YYYY-MM-DD');
		const departureTime = editedAttendee.roomingInformation.departureTime;
		const checkOutDate = moment(`${editedAttendee.roomingInformation.checkOutDate}`).format('YYYY-MM-DD');

		// Convert to MM/DD/YYYY and create variables
		const flightArrival = editedAttendee.travelInformation.arrivalDate
			? moment(editedAttendee.travelInformation.arrivalDate).format('MM/DD/YYYY')
			: '';
		const hotelCheckin = editedAttendee.roomingInformation.checkInDate
			? moment(editedAttendee.roomingInformation.checkInDate).format('MM/DD/YYYY')
			: '';
		const eventArrival = editedAttendee.roomingInformation.arrivalDate
			? moment(editedAttendee.roomingInformation.arrivalDate).format('MM/DD/YYYY')
			: '';

		const isFlightValid = flightArrival && flightArrival !== 'Invalid date';
		const isEventValid = eventArrival && eventArrival !== 'Invalid date';
		const isHotelValid = hotelCheckin && hotelCheckin !== 'Invalid date';

		const FlightArrival = isFlightValid ? flightArrival + " - Flight Arrival" : "No Date Set - Flight Arrival";
		const EventArrival = isEventValid ? eventArrival + " - Event Arrival" : "No Date Set - Event Arrival";
		const HotelCheckin = isHotelValid ? hotelCheckin + " - Hotel Check In" : "No Date Set - Hotel Check In";

		const hotelHasConflict = (isFlightValid && isHotelValid && flightArrival !== hotelCheckin) ||
			(isEventValid && isHotelValid && eventArrival !== hotelCheckin);
		const eventHasConflict = (isFlightValid && isEventValid && flightArrival !== eventArrival) ||
			(isEventValid && isHotelValid && eventArrival !== hotelCheckin);

		// Convert to MM/DD/YYYY and create variables for departures
		const flightDeparture = editedAttendee.travelInformation.departureDate
			? moment(editedAttendee.travelInformation.departureDate).format('MM/DD/YYYY')
			: '';
		const hotelCheckout = editedAttendee.roomingInformation.checkOutDate
			? moment(editedAttendee.roomingInformation.checkOutDate).format('MM/DD/YYYY')
			: '';
		const eventDeparture = editedAttendee.roomingInformation.departureDate
			? moment(editedAttendee.roomingInformation.departureDate).format('MM/DD/YYYY')
			: '';

		const isFlightDepartureValid = flightDeparture && flightDeparture !== 'Invalid date';
		const isEventDepartureValid = eventDeparture && eventDeparture !== 'Invalid date';
		const isHotelCheckoutValid = hotelCheckout && hotelCheckout !== 'Invalid date';

		const FlightDeparture = isFlightDepartureValid ? flightDeparture + " - Flight Departure" : "No Date Set - Flight Departure";
		const EventDeparture = isEventDepartureValid ? eventDeparture + " - Event Departure" : "No Date Set - Event Departure";
		const HotelCheckout = isHotelCheckoutValid ? hotelCheckout + " - Hotel Check Out" : "No Date Set - Hotel Check Out";

		const flightDepartureHasConflict = (isFlightDepartureValid && isHotelCheckoutValid && flightDeparture !== hotelCheckout) ||
			(isFlightDepartureValid && isEventDepartureValid && flightDeparture !== eventDeparture);
		const hotelCheckoutHasConflict = (isFlightDepartureValid && isHotelCheckoutValid && flightDeparture !== hotelCheckout) ||
			(isEventDepartureValid && isHotelCheckoutValid && eventDeparture !== hotelCheckout);
		const eventDepartureHasConflict = (isFlightDepartureValid && isEventDepartureValid && flightDeparture !== eventDeparture) ||
			(isEventDepartureValid && isHotelCheckoutValid && eventDeparture !== hotelCheckout);

		let icon = eventHasConflict ? <i id="Popover1" onMouseEnter={this.toggle} onMouseLeave={this.toggle} className="las la-lg la-exclamation-triangle red" /> : false;

		let icon2 = hotelHasConflict ? <i id="Popover2" onMouseEnter={this.toggle2} onMouseLeave={this.toggle2} className="las la-lg la-exclamation-triangle red" /> : false;

		let icon3 = eventDepartureHasConflict ? <i id="Popover3" onMouseEnter={this.toggle3} onMouseLeave={this.toggle3} className="las la-lg la-exclamation-triangle red" /> : false;

		let icon4 = hotelCheckoutHasConflict ? <i id="Popover4" onMouseEnter={this.toggle4} onMouseLeave={this.toggle4} className="las la-lg la-exclamation-triangle red" /> : false;

		return (
			<>
				<h2 className='blockHeader '>Rooming Information</h2>

				<div className='blocksContainer'>
					<div className='sectionBlock'>
						<div >
							{eventHasConflict && (
								<Popover placement="left" className="popoverWarrning" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggle}>
									<PopoverBody> Notice: Date mismatch </PopoverBody>
									<PopoverBody className="popoverWarrningBody">
										<div>{FlightArrival} </div>
										<div>{EventArrival} </div>
										<div>{HotelCheckin} </div>
									</PopoverBody>
								</Popover>
							)}

							<InputField
								label={'Arrival Date'}
								warningIcon={icon}
								type={'date'}
								value={arrivalDate}
								inputIcon={<i className="lar la-calendar" />}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											arrivalDate: e.target.value 
										}
									});
								}}
							/>

							<TimeField
								label={'Arrival Time'}
								value={arrivalTime}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											arrivalTime: e
										}
									});
								}}
							/>
							{hotelHasConflict && (
								<Popover placement="left" className="popoverWarrning" isOpen={this.state.popoverIsOpen} target="Popover2" toggle={this.toggle2}>
									<PopoverBody> Notice: Date mismatch </PopoverBody>
									<PopoverBody className="popoverWarrningBody">
										<div>{FlightArrival} </div>
										<div>{EventArrival} </div>
										<div>{HotelCheckin} </div>
									</PopoverBody>
								</Popover>
							)}
							<InputField
								label={'Check In Date'}
								type={'date'}
								warningIcon={icon2}
								value={checkInDate}
								inputIcon={<i className="lar la-calendar" />}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											checkInDate: e.target.value
										}
									});
								}}
							/>

					{eventDepartureHasConflict && (
						<Popover placement="left" className="popoverWarrning" isOpen={this.state.popoverOpen3} target="Popover3" toggle={this.toggle3}>
							<PopoverBody> Notice: Date mismatch </PopoverBody>
							<PopoverBody className="popoverWarrningBody">
								<div>{FlightDeparture} </div>
								<div>{EventDeparture} </div>
								<div>{HotelCheckout} </div>
							</PopoverBody>
						</Popover>
					)}
					<InputField
						label={'Departure Date'}
						warningIcon={icon3}
						type={'date'}
						value={departureDate}
						inputIcon={<i className="lar la-calendar" />}
						onChange={(e) => {
							this.props.toggleEditing(true);
							this.props.editRoomingFields({
								...this.props.editedAttendee,
								roomingInformation: {
									...this.props.editedAttendee.roomingInformation,
									departureDate: e.target.value
								}
							});
						}}
					/>

					<TimeField
						label={'Departure Time'}
						value={departureTime}
						onChange={(e) => {
							this.props.toggleEditing(true);
							this.props.editRoomingFields({
								...this.props.editedAttendee,
								roomingInformation: {
									...this.props.editedAttendee.roomingInformation,
									departureTime: e
								}
							});
						}}
					/>

					{hotelCheckoutHasConflict && (
						<Popover placement="left" className="popoverWarrning" isOpen={this.state.popoverIsOpen4} target="Popover4" toggle={this.toggle4}>
							<PopoverBody> Notice: Date mismatch </PopoverBody>
							<PopoverBody className="popoverWarrningBody">
								<div>{FlightDeparture} </div>
								<div>{EventDeparture} </div>
								<div>{HotelCheckout} </div>
							</PopoverBody>
						</Popover>
					)}
					<InputField
						label={'Check Out Date'}
						type={'date'}
						warningIcon={icon4}
						value={checkOutDate}
						inputIcon={<i className="lar la-calendar" />}
						onChange={(e) => {
							this.props.toggleEditing(true);
							this.props.editRoomingFields({
								...this.props.editedAttendee,
								roomingInformation: {
									...this.props.editedAttendee.roomingInformation,
									checkOutDate: e.target.value
								}
							});
						}}
					/>							
							<InputField
								label={'Number of Nights'}
								value={editedAttendee.roomingInformation.numberOfDaysStay}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											numberOfDaysStay: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Room Type'}
								value={editedAttendee.roomingInformation.roomType}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											roomType: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Hotel Confirmation Number'}
								value={editedAttendee.roomingInformation.hotelConfirmationNumber}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											hotelConfirmationNumber: e.target.value
										}
									});
								}}
							/>

							<SelectField
								label={'Payment Type'}
								value={paymentOptions.find((option) => option.value === editedAttendee.roomingInformation.paymentType)}
								options={paymentOptions}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											paymentType: e.value
										}
									});
								}}
							/>
							<TextAreaField
								placeholder={''}
								value={editedAttendee.roomingInformation.notes}
								label="Rooming Notes"
								type="text"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editRoomingFields({
										...this.props.editedAttendee,
										roomingInformation: {
											...this.props.editedAttendee.roomingInformation,
											notes: e.target.value
										}
									});
								}}
							/>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default EventAttendeeRooming;
